import { IconButton, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react'

import { CgOptions } from "react-icons/cg";
import { displayReactIcon } from '../../../digital-sales-room/helpers/dsr-display-helpers';

export default function JoinRequestCardOptionsButton({ 
  dsrId, 
  dsrTitle,
  handleChangeUserActionRequired,
}) {

  const handleDeleteJoinRequest = () => {
    handleChangeUserActionRequired('delete-join-room-request', {dsrId, dsrTitle})
  }
  

  return (
    <>
      <Menu isLazy placement="bottom-end" >
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<CgOptions />}
          variant='outline'
          size='2em'
          p='0.25em'
        />
        <Portal>
        <MenuList px='0.5em' fontSize='0.875em'>
          <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => handleDeleteJoinRequest()} >{displayReactIcon("remove","1.5em") }Delete request</MenuItem>
        </MenuList>
        </Portal>
      </Menu>

    </>
  );

}